import {
  useEffect, useState,
} from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { usePrevious } from 'Utils/hooks/usePrevious';
import { Company } from 'Types/CompaniesTypes';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import AddCompanyLimitPopup from 'Components/common/modal/AddCompanyLimitPopup';
import CompaniesSection from 'Components/company/components/CompaniesSection';
import RecommendedCompaniesSection from 'Components/company/components/RecommendedCompaniesSection';

import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { IsTablet } from 'Utils/UtilityFunctions';
import classNames from 'classnames';
import { selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import { actions as UiAction } from 'Slice/UISlice';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import CompaniesIcon from '../../Components/company/svgIcons/CompaniesIcon';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';

import {
  selectCompanies,
  selectedSortingType, selectRecommendedCompanies,
  selectRecommendedCompaniesLoading,
} from '../../Selector/CompaniesSelector';
import { Gilroy } from 'Components/gilroy/LazyGilroy';
import { useGilroy } from 'Utils/hooks/useGilroy';

const OnboardingPage = function OnboardingPage() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const { saveUrl: savedUrlV2 } = chatStates;
  const companiesLength: number = useSelector(selectCompanies).length;
  const recommendedCompanies: Company[] = useSelector(selectRecommendedCompanies);
  const recommendedLoading: boolean = useSelector(selectRecommendedCompaniesLoading);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;
  const previousRecommendedCompanies = usePrevious(recommendedCompanies);
  const sortingType = useSelector(selectedSortingType);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(companiesActions.getRecommendedCompanies({
      page: 1,
    }));
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }

    return () => {
      dispatch(companiesActions.resetCompaniesData({}));
    };
  }, []);

  useEffect(() => {
    if (
      previousRecommendedCompanies
      && previousRecommendedCompanies?.length !== recommendedCompanies?.length
      && recommendedCompanies.length < 4 && !recommendedLoading
    ) {
      dispatch(companiesActions.getRecommendedCompanies({
        page: 1,
      }));
    }
  }, [recommendedCompanies]); // useEffect

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  return (
    <>
      <NavBarPrimary headerClassName="headers-space box-shadow  no-overflow-on-header">
        <div className="left-side-wrap">
          <CompaniesIcon />
          <h1 className="heading">Companies</h1>
        </div>
        <div className={classNames('right-side-wrap', { highlightedComponent: false })} id="certification-global-search">
          <GlobalSearch
            highlighted
            iconMode={IsTablet()}
          />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <div className="container">
        <AddCompanyLimitPopup />
        <CompaniesSection />
        <RecommendedCompaniesSection />
        <DrawerPeopleGroup
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          disableDrop
          noButton
        />
      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </>
  );
};

export default OnboardingPage;
